module.exports = __webpack_public_path__ + "img/9791187700241.f29a6908.jpg";